//  类型判断

function isType (type) {
  // let currentType = Object.prototype.toString.call(content).replace(/\[object\s|\]/g, '')
  // return currentType === type
  return function (content) {
    let currentType = Object.prototype.toString.call(content).replace(/\[object\s|\]/g, '')
    return currentType === type
  }
}
// let isString = isType('String')
// console.log(isString('abc'))
let types = ['Array', 'String', 'Number', 'Object', 'NULL', 'Boolean']
let util = {}
types.forEach((item) => {
  util[`is${item}`] = isType(item)
})
export default util